import { render, staticRenderFns } from "./CalendarEventEditorPeriodicity.vue?vue&type=template&id=89fd34c6&scoped=true&lang=pug&"
import script from "./CalendarEventEditorPeriodicity.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorPeriodicity.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventEditorPeriodicity.vue?vue&type=style&index=0&id=89fd34c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fd34c6",
  null
  
)

export default component.exports